
import sfiDevelop from './app-config.sfi-develop.json'
import sfiRelease from './app-config.sfi-release.json'
import fpacIntegration from './app-config.fpac-integration.json'
import fpacCertification from './app-config.fpac-certification.json'
import fpacProduction from './app-config.fpac-production.json'
import unitTest from './app-config.unit-test.json'
import localBackend from './app-config.local-backend.json'
/* istanbul ignore file */
let activeConfig: IAppConfig = sfiDevelop
// use meta tag to determin active config
const metaTags: any = document.getElementsByName("nets-app-config");
let configName = metaTags.length > 0 ? metaTags[0].content : "DEFAULT";


const versionTags: any = document.getElementsByName("nets-app-version");
const commitTags: any = document.getElementsByName("nets-app-commit-hash");

export const configValue = configName;
export const versionValue = versionTags.length > 0 ? versionTags[0].content : "UNKNOWN";
export const commitValue = commitTags.length > 0 ? commitTags[0].content : "UNKNOWN";
if (configName == "DEFAULT") {
    // assume running with unit-test configuration when location = http://localhost/
    // assume running with sfi-develop configuration when location = http://localhost:3000
    // assume running with sfi-develop configuration when location = https://web1-eft.spatialfrontlab.com
    // assume running with sfi-release configuration when location = https://web1-eft.efttest.spatialfrontlab.com
    if (document.location.toString().startsWith("http://localhost/")) {
        configName = "unit-test"
    } else if (document.location.toString().startsWith("http://localhost:3097")) {
        configName = "local-backend"
    } else if (document.location.toString().startsWith("http://localhost:")) {
        configName = "sfi-develop"
    } else if (document.location.toString().startsWith("https://web1-eft.spatialfrontlab.com")) {
        configName = "sfi-develop"
    } else if (document.location.toString().startsWith("https://web1-eft.efttest.spatialfrontlab.com")) {
        configName = "sfi-release"
    } else if (document.location.toString().startsWith("https://eft-dev-aws.dev.sc.egov.usda.gov")) {
        configName = "fpac-integration"
    }
}

if (configName == "unit-test") {
    activeConfig = unitTest;
    // console.log("config set to unit-test")
} else if (configName == "local-backend") {
    activeConfig = localBackend;
} else if (configName == "sfi-develop") {
    activeConfig = sfiDevelop;
    // console.log("config set to sfi-develop")
} else if (configName == "sfi-release") {
    activeConfig = sfiRelease;
    // console.log("config set to sfi-release")
} else if (configName == "fpac-integration") {
    activeConfig = fpacIntegration;
    // console.log("config set to fpac-integration")
} else if (configName == "fpac-certification") {
    activeConfig = fpacCertification;
    // console.log("config set to fpac-certification")
} else if (configName == "fpac-production") {
    activeConfig = fpacProduction;
    // console.log("config set to fpac-production")
} else {
    throw new Error("Unrecognized config name");
}

export const appConfig = activeConfig;

interface IAppConfig {
    releaseVersion: string;
    configVersion: string;
    environmentName: string;
    ffsEnvironmentName: string;
    userIdentityProvider: string;
    useEAuth: boolean;
    useAtun: boolean;
    atun: string;
    eAuthBasePath: string;
    enableGlossaryService: boolean;
    enableLogout: boolean;
    endpoints: {
        eftAuthenApiBasePath: string;
        eftPrjAdminApiBasePath: string;
        eftEfh2ApiBasePath: string;
        eftSetApiBasePath: string;
        eftCleaningApiBasePath: string;
        fpacFFSBasePath: string;
    };
    hydrologyGisLayers: {
        rainfallFeatureLayer: string
    };
    usdaNaipSources: {
        baseMapPath: string,
        nonTiledPath: string,
        thumbnailPath: string
    };
    gpSessionRoot: string;
    demGeotiffFolder: string;
    hydrologyRefactorGpApiConfig: {
        timeout: number;
        baseUrl: string;
        createSessionFolderPath: string;
        deleteSessionFolderPath: string;
        loadSessionPath: string;
        exportSessionPath: string;
        convertGdbToGeotiffPath: string;
        invalidateSessionPath: string;
        uploadDEMPath: string;
        generateAOIDEMPath: string;
        generateContoursPath: string;
        generateHillshadePath: string;
        generateDepthGridPath: string;
        generateStreamlinesPath: string;
        generateWatershedPath: string;
        updateWatershedPath: string;
        prepareLULCPath: string;
        prepareSoilsPath: string;
        calculateRcnPath: string;
        lulcMapServer: string;
        soilMapServer: string;
    };
    delineateWatershedGpApiConfig: {
        timeout: number;
        baseUrl: string;
        delineateWatershedPath: string;
        createSessionFolderPath: string;
        deleteSessionFolderPath: string;
        loadSessionEFH2Path: string;
        exportSessionEFH2Path: string;
        prepareSalPath: string;
        calculateRcnPath: string;
        lulcMapServer: string;
        soilMapServer: string;
    };
    demSurfaceGpApiConfig: {
        timeout: number;
        baseUrl: string;
        demUploadPath: string;
        createSessionFolderPath: string;
        deleteSessionFolderPath: string;
        loadSessionEFH2Path: string;
        exportSessionEFH2Path: string;
        loadDEMFromSession: string;
    };
    surfaceDesignGpApiConfig: {
        basePath: string;
        SurfaceGenerationTool: string;
        SurfaceSaveManagement: string;
        EftExporterTool: string;
        JsonToSurface: string;
    };
    tempHardCodes: ITempHardCodes;
    hardCodes: IHardCodes;
    navigationFlags: {
        enableHomepage: boolean;
        enableProjects: boolean;
        enableDesign: boolean;
        enableAnalysis: boolean;
        enableHydrology: boolean;
        enableSingleWatershed: boolean;
        enableAnimalWaste: boolean;
        enableHydraulicFormula: boolean;
        enableWaterwayWizard: boolean;
        enableDashboard: boolean;
        enableTraining: boolean;
        redirectDesignToProjects: boolean;
        redirectSingleWatershedToProjects: boolean;
    };
    projectFlags: {
        enableCreateProject: boolean;
        enableProjectDetails: boolean;
        enableDownloadProject: boolean;
        enableCopyLink: boolean;
        enableLoadProject: boolean;
        enableDeleteProject: boolean;
    };
    designFlags: {
        enableSurface: boolean;
        enableAlignment: boolean;
        enableTerrace: boolean;
        enableUGO: boolean;
        enableWaterway: boolean;
        enablePit: boolean;
        enablePond: boolean;
        enablePipeline: boolean;
        enablePad: boolean;
        enableLandLeveling: boolean;
        enableSettings: boolean;
    };
    setEndpoints: {
        baseSetPath: string;
        basePath: string;
        basePathForSo: string;
        basePathForStructure: string;
        loadSurvey: string;
        editSurvey: string;
        addDesignElement: string;
        getDesignElement: string;
        getAllDesignElements: string;
        getAllDesignElementsBySessionAndType: string;
        getSurveyPoints: string;
        getLandLevelingCentroid: string;
        getLandLevelingBestFit: string;
        getElevation: string;
        delete: string;
        getAlignmentsMetadata: string;
        getAllDesignElementsBySession: string;
        downloadLandXML: string;
        generateLandLevelingCSV: string;
        deleteDesignElement: string;
        updateStructureDesignElement: string;
        createSurfaceDef: string;
        getSurfaceDefSurveyMetadataById: string;
        getSurfaceDefById: string;
        getSurfaceDefBySession: string;
        editSurface: string;
        addDesignElementJsonForAlignment: string;
        alignmentAOIupdateShape: string;
        getErrorHandlingByOriginalErrorCode: string;
        exportAlignmentsToCSV: string;
        downloadDEM: string;
    };
    esriIdentityManager: { refererUrlTokens: IRefererUrlTokens[] };
    demMapServices: IDemMapObject[];
}
interface IDemMapObject {
    id: string;
    title: string;
    url: string;
    metadata: string;
    units: string;
    hillshadeName: string;
}
interface ITempHardCodes {
    wkid: number;
    designProjectId: string;
    designSessionId: string;
    surfaceDefId: number;
    designElementId: number;
    zUnits: number;
    xMin: number;
    xMax: number;
    yMin: number;
    yMax: number;
    shape: string;
    surfaceJson: string;
    surfaceDefTitle: string;
    surfaceDefClass: {
        surfaceDefClassId: number;
        surfaceDefClassName: string;
    },
    surfaceDefType: {
        surfaceDefTypeId: number;
        surfaceDefTypeName: string;
    },
    sessionResource: {
        sessionResourceId: number;
    },
    surfaceExpressMode: boolean;
};

interface IHardCodes {
    designElementTypeDrawing: number;
    designElementTypeSuface: number;
    designElementTypeTerrace: number;
    designElementTypeTerraceGradient: number;
    designElementTypeTerraceLevel: number;
    designElementTypeTerraceStorage: number;
    designElementTypeTerraceWascob: number;
    designElementTypeUGO: number;
    designElementTypeIndependent: number;
    designElementTypeWaterway: number;
    designElementTypePitRectangular: number;
    designElementTypePitRound: number;
    designElementTypePitDiked: number;
    designElementTypePad: number;
    designElementTypeLandLeveling: number;
    designElementTypeSpredsheet: number;
    designElementTypeCrossSlope: number;
    surveyTypeXYZ: number;
    surveyTypeSpredsheet: number;
    surveyTypeCrossSlope: number;
    activityLogDefaultPaginationRecords: number;
};

interface IRefererUrlTokens {
    refererStartsWith: string;
    urlTokens: IUrlTokens[];
}
interface IUrlTokens {
    url: string;
    token: string;
    expires: number;
    note: string;
}